/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';
import { daysFromNow } from '@zapier/date';
import { Alert, Link } from '@zapier/design-system';
import { Price } from '@zapier/currency';

import type { ResponseData } from '../useAlertBanner/useAlertBannerData';
import { BannerProps } from './types';
import { Fragment } from 'react';

import { useUniversalNavContext } from '../../../../universal-nav/hooks';
import { getProfessionalPlanData } from './utils';

export const shouldRender = (data: ResponseData, isExcludedUrl = false) => {
  const { isTrialing, trialEndDate } = data.currentAccount;
  return !!isTrialing && !!trialEndDate && !isExcludedUrl;
};

export const Component = function ProfessionalTrialing(props: BannerProps) {
  const { data, currency } = props;
  const { currentAccount, possiblePlans } = data;

  const { getFullyQualifiedURL } = useUniversalNavContext();

  const { trialEndDate } = currentAccount;
  const trialDaysRemaining = daysFromNow(trialEndDate!);
  const daysText = trialDaysRemaining === 1 ? 'day' : 'days';

  const { professionalUpgradeUrl, professionalPlanAmount } =
    getProfessionalPlanData(possiblePlans, currentAccount);

  const upgradeUrl = professionalUpgradeUrl;
  const nextPlanAmount = professionalPlanAmount;

  const onClickLink = () => {
    props.trackEvent('Trial: clicked banner');
  };

  return (
    <Alert
      layout={props.layout}
      title="Welcome to your Professional trial!"
      type="info"
    >
      <p>
        {`You have ${trialDaysRemaining} ${daysText} to try Zapier’s `}
        <Link
          href={getFullyQualifiedURL(
            '/help/account/billing-pricing/understand-your-zapier-premium-trial'
          )}
          onClick={onClickLink}
        >
          paid features
        </Link>
        .{' '}
        <Fragment>
          <Link href={upgradeUrl} onClick={onClickLink}>
            Upgrade
          </Link>{' '}
          anytime
          {nextPlanAmount > 0 && (
            <span>
              {' '}
              for as low as <Price currency={currency}>{nextPlanAmount}</Price>
              /month.
            </span>
          )}
        </Fragment>
      </p>
    </Alert>
  );
};
